module.exports = __webpack_public_path__ + "static/itsm_capabilities_3_7-0e4fcad74bcef26ffc31717100bcd773.png";